<ng-container *ngLet="(freeTextFieldItems | filterByProperty : 'isActive' : true) as subtabs">
  <ng-container
    *ngIf="(screenSizeService.isHandset$ | async) === false; else subtabs?.length ? handsetTemplate : noSubtabs"
  >
    <div class="pageSubHeader">
      <app-section-title svgIcon="format-align-left" [title]="freeTextFieldTitle" headerSize="h4"></app-section-title>
    </div>
    <ng-container *ngIf="subtabs?.length; else noSubtabs">
      <div class="border-top"></div>
      <app-horizontal-navigation>
        <div class="customHorizontalNavContainer">
          <button
            *ngFor="let subtab of subtabs; trackBy: trackSubtabs"
            mat-flat-button
            class="mr-2 horizontalNavButton text-transform-initial"
            [routerLink]="[subtab.id]"
            routerLinkActive="mat-secondary"
            (click)="onSubtabChanged(subtab.id)"
            [attr.data-testId]="subtab.name"
          >
            {{subtab.name}}
          </button>
        </div>
      </app-horizontal-navigation>
    </ng-container>
  </ng-container>

  <ng-template #noSubtabs>
    <div class="px-spacer-responsive py-3 border-top">
      <i i18n="@@dprDetails.dprFreeTextFieldsPage.txtNoActiveTabs">
        You have no active subtabs. Go to Project Setup -> Free Text Fields in order to add or activate any.
      </i>
    </div>
  </ng-template>

  <ng-template #handsetTemplate>
    <app-navigation-select
      [items]="subtabs | mapNavigationMenuItem : 'id' : 'name' : 'id'"
      [initialSelection]="preselectedItem"
      (selectedItemChanges)="onSubtabChanged(+($event))"
    ></app-navigation-select>
  </ng-template>

  <router-outlet *ngIf="subtabs.length" (activate)="onComponentActivated($event)"></router-outlet>
</ng-container>
